export default __webpack_public_path__ + "static/media/empty-orders.15b11826.svg";